/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {servicosRoute} from "./servicos/shared/data.service";
import {configuracaoRoute} from "../shared/services/data.service";
import {ManutencaoConfiguracaoComponent} from "./configuracao/manutencao-configuracao.component";
import {AuthGuardService} from "../shared/services/auth-guard.service";
import {ServicosComponent} from "./servicos/servicos.component";
import {servicosRoutes} from "./servicos/servicos-routing.module";
import {planosRoute} from "./planos/shared/data.service";
import {PlanosComponent} from "./planos/planos.component";
import {planosRoutes} from "./planos/planos-routing.module";
import {ordensServicoRoute} from "./ordens-servico/shared/data.service";
import {OrdensServicoComponent} from "./ordens-servico/ordens-servico.component";
import {ordensServicoRoutes} from "./ordens-servico/ordens-servico-routing.module";
import {manutencoesProgramadaRoute} from "./manutencao-programada/shared/data.service";
import {ManutencaoProgramadaComponent} from "./manutencao-programada/manutencao-programada.component";
import {manutencaoProgramadaRoutes} from "./manutencao-programada/manutencao-programada-routing.module";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class ManutencoesRoutingModule {}

export const manutencoesRoutes: any[] = [
    {
        path: '',
        redirectTo: '/' + servicosRoute,
        pathMatch: 'full'
    },{
        path: configuracaoRoute,
        component: ManutencaoConfiguracaoComponent,
        canActivate: [AuthGuardService]
    },{
        path: configuracaoRoute + '/' + servicosRoute,
        component: ServicosComponent,
        canActivate: [AuthGuardService],
        children: servicosRoutes
    },{
        path: configuracaoRoute + '/' + planosRoute,
        component: PlanosComponent,
        canActivate: [AuthGuardService],
        children: planosRoutes
    },{
        path: servicosRoute,
        component: ServicosComponent,
        canActivate: [AuthGuardService],
        children: servicosRoutes
    },{
        path: planosRoute,
        component: PlanosComponent,
        canActivate: [AuthGuardService],
        children: planosRoutes
    },{
        path: ordensServicoRoute,
        component: OrdensServicoComponent,
        canActivate: [AuthGuardService],
        children: ordensServicoRoutes
    },{
        path: manutencoesProgramadaRoute,
        component: ManutencaoProgramadaComponent,
        canActivate: [AuthGuardService],
        children: manutencaoProgramadaRoutes
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencoes-routing.module.ts
 **/